import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LearnSubSectionId = Brand<number, 'TryThisSubSectionId'>;
export const LearnSubSectionId = createBranded<LearnSubSectionId>();
